export default __webpack_public_path__ + "static/media/330_private01-nl-mobile.9eb4bcf9.png";